<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="save" v-show="this.showGrant">
              저장
            </el-button>
            <el-button type="danger" icon="el-icon-delete-solid" @click="buttonClickEventRemove" v-show="this.showGrant">
              삭제
            </el-button>
            <el-button type="info" icon="el-icon-close" @click="cancel">
              취소
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelUpload">
              엑셀업로드
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="설치요청일" label-width="100px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: start;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-form-item label="지역/설치센터" label-width="120px">
                  <el-col :span="10">
                    <el-select v-model="form.catId" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['catId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="14">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="고객구분" label-width="100px">
                <el-select v-model="form.siteType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['siteType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="사이트명" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="goOpen"></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="goOpen"></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="goOpen"></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @cell-clicked="onCellClickedSub"
                @grid-ready="onReadyMain" />
          </div>
        </div>
      </div>
    </div>
    <product-install-edit-info v-if="productInstallEditDetail" ref="productInstallEditInfo" :productInstallEditDetail="productInstallEditDetail" style="height: 100%"/>
  </div>
</template>

<script>

import lucoms from '@/mixin/lucoms';

import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ProductInstallEditInfo from '@/components/WorkMng/ProductInstall/ProductInstallEditInfo.vue';
import UploadExcel from '@/components/WorkMng/ProductInstall/ProductInstallUploadExcel.vue';

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [lucoms],
  props: {
  },
  components: {ProductInstallEditInfo},
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        // startDt: this.$moment().subtract(1, 'months').add(1, 'days').format('YYYY-MM-DD'),
        startDt: this.$moment().format('YYYY-MM-01'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        maType : '',             // 의뢰구분
        siteType : '',           // 고객구분
        catId : '',              // 지역
        subCatId: '',            // 지역상세
        sortType : '',           // 승인/정산처리유형
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'maType' : [],
        'catId' : [],
        'subCatId' : [],
        'siteType' : []
      },
      changeCatIdShow : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 10px; width: 100%;height: 300px; min-height:100px;',
      defaultColDef: {
        resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      showGrant: true,
      statusBar: null,
      productInstallEditDetail: []
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      const vm = this
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'의뢰번호', field:'requestId', width:150},
        {headerName:'의뢰일자', field:'requestDt', width:110, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'의뢰자', field:'requestNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNms', width:160,
          valueGetter: (params) => {
            return params.data.siteNm1 + ' ' + params.data.siteNm2 + ' ' + params.data.siteNm3
          }},
        {headerName:'주소', field:'addrs', width:160,
          valueGetter: (params) => {
            return params.data.addr1 + ' ' + params.data.addr2
          }},
        {headerName:'고객명', field:'chargeNm', width:160},
        {headerName:'전화번호', field:'telNo', width:140},
        {headerName:'휴대폰', field:'hpNo', width:140},
        {headerName:'설치센터', field:'asAgentNm', width:140},
        {headerName:'설치요청일', field:'requestSetupDt', width:130, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'설치완료일', field:'setupDt', width:130, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
          }},
      ];
    },
    onCellClickedSub(params) {
      this.gridApiSub = this.mainGridOptions.api;
      // const voRow = this.gridApiSub.getSelectedRows() //선택된 Row
      const requestId = params.data.requestId;
      //this.productInstallEditDetail = []; // 초기화
      let that = this
      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        requestId: requestId,
        processTime : ''
      }
      this.$http.post(_url("/api/workMng/productInstallEdit/selectList"), vForm)
          .then(response => {
            this.productInstallEditDetail = response.data;
            this.productInstallEditDetail.modelSetupSelItem[0].siteTypeCombo = this.combos['siteType'];
            this.productInstallEditDetail.modelSetupSelItem[0].yearsCombo = this.combos['years'];
            this.showGrant = this.productInstallEditDetail.modelSetupSelItem[0].procYn == 'Y' ? false : true;
          }).finally(() => {
        //this.$refs.productInstallEditInfo.dataClear();
        this.$store.commit('finish')
      });
    },
    cancel(){
      this.$refs.productInstallEditInfo.form = this.$refs.productInstallEditInfo.defForm;
      this.$refs.productInstallEditInfo.data = [];
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        siteType : this.form.siteType,          // 고객구분
        siteNm1 : this.form.siteNm1,            // 사이트명1
        siteNm2 : this.form.siteNm2,            // 사이트명2
        siteNm3 : this.form.siteNm3,            // 사이트명3
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        subCatId: '',                           // 지역 상세
        sortType : this.form.sortType,          // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/productInstallEdit/list"), vForm)
          .then(response => {
            this.data = response.data.map(x=>{
              x.siteNms = (x.siteNm1 || '') + ' ' + (x.siteNm2 || '') + ' ' + (x.siteNm3 || '')
              return x
            });

          }).finally(() => {
        // this.$refs.productInstallEditInfo.dataClear();
        // this.$refs.productInstallEditInfo.data.dataClear();
        this.cancel();
        this.$store.commit('finish')
      });
    },
    excelUpload(){
      /** 엑셀업로드 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: UploadExcel,
        parent: this,
        props: {
          data: {

          },
        },
        events: {
          close(param) {
            vm.goOpen();
          },
        }
      });

    },
    updateCount(){
      if(!this.$refs.productInstallEditInfo.validation()) return;

      this.$swal({
        type: 'info',
        text: `입고 수량을 수정 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          const productInstallEditInfo = JSON.parse(JSON.stringify(this.$refs.productInstallEditInfo.form));

          this.$http.get(`/api/asMng/call/config`, {params: {keyPath: 'System.MainAsAgentId'}})
              .then(response => {
                productInstallEditInfo.asAgentId = response.data[0].configValue
                this.$http.post(`/api/workMng/mateEntering/update`, productInstallEditInfo).then((response) => {
                  this.$swal({type: 'info', text: '저장되었습니다.'});
                  this.goOpen();
                }).catch((e) => {
                  this.$swal({type: 'error', text: e.response.data.message});
                });

              });
        }
      });
    },
    buttonClickEventRemove() {
      try{
        const selectedRows = this.mainGridOptions.api.getSelectedRows()

        //Selected Index
        const row = this.mainGridOptions.api.getSelectedNodes()
        const rowIndex = row.length < 1 ? -1 : row[0].rowIndex
        const voRow = row[0].data;

        if(selectedRows == null|| rowIndex<0) throw '선택된 행이 없습니다.'

        this.$swal({
          type: 'warning',
          text: `삭제하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {
          if (result.value) {
            this.$store.commit('loading');
            this.$http.post('/api/workMng/productInstallEdit/cancel', {
              companyId: this.$store.state.loginInfo.compCd,
              requestId: voRow.requestId
            }).then(response => {
              if (response) {
                this.$swal({type: 'success', text: '삭제되었습니다.'});
                // this.data.splice(rowIndex,1)
                // this.focusRow(rowIndex-1);
                this.goOpen();
              }
            }).catch(({message}) => {
              if (message === "Request failed with status code 500") {
                this.$swal({type: "error", text: "오류가 발생했습니다."});
              }
            }).finally(() => {
              this.$store.commit('finish');
            })
          }
        })
      }catch(e){
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/bsMaEdit/init`)
          .then(response => {
            this.combos['maType'] = response.data.maType;
            this.combos['catId'] = response.data.catId;
            this.combos['siteType'] = response.data.siteType;
            this.combos['years'] = response.data.years;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    validation(param) {
      if (!param.requestDt ) {
        this.$swal({type: 'warning', text: '의뢰일자를 입력해주세요.'});
        return false;
      }
      if (!param.requestNm ) {
        this.$swal({type: 'warning', text: '의뢰자를 입력해주세요.'});
        return false;
      }
      if (!param.requestNm ) {
        this.$swal({type: 'warning', text: '구분을 선택해주세요.'});
        return false;
      }
      if (!param.custType ) {
        this.$swal({type: 'warning', text: '찾기버튼을 통해서 사이트를 선택해주세요.'});
        return false;
      }
      if (!param.siteId ) {
        this.$swal({type: 'warning', text: '찾기버튼을 통해서 사이트를 선택해주세요.'});
        return false;
      }
      if (!param.modelQty ) {
        this.$swal({type: 'warning', text: '의뢰대수를 입력해주세요.'});
        return false;
      }
      if (!param.requestProcDt ) {
        this.$swal({type: 'warning', text: '설치요청일을 입력해주세요.'});
        return false;
      }



      // itemId = <%= ddlBSMA.ClientID %>_GetId();
      // item = <%= ddlBSMA.ClientID %>_GetItem();
      // if(IsReject(itemId == "0" || itemId == "", "구분을 선택해주세요",item)) return false;
      //
      // item = document.getElementById("<%= hddCUST_TYPE.ClientID %>");
      // if(IsReject(item == "" || item == "0", "찾기버튼을 통해서 사이트를 선택해주세요")) return false;
      //
      // item = document.getElementById("<%= hddSITE_ID.ClientID %>");
      // if(IsReject(item.value == "" || item.value == "0","찾기버튼을 통해서 사이트를 선택해주세요.",item)) return false;
      //
      //
      // item = document.getElementById("<%= hddMODEL_ID.ClientID %>");
      // if(IsReject(item.value == "" || item.value == "0","찾기버튼을 통해서 모델을 선택해주세요.",item)) return false;
      //
      // item = document.getElementById("<%= txtMODEL_QTY.ClientID %>");
      // if(IsReject(item.value == "" || item.value == "0","의뢰대수를 입력해주세요.",item)) return false;
      //
      // item = document.getElementById("<%= txtREQUEST_PROC_DT.ClientID %>");
      // if(IsReject(item.value == "","설치요청일을 입력해주세요",item)) return false;
      //
      // itemId = <%= ddlAS_AGENT_ID.ClientID %>_GetId();
      // itemLevel = <%= ddlAS_AGENT_ID.ClientID %>_GetLevel();
      // item = <%= ddlAS_AGENT_ID.ClientID %>_GetItem();
      // if(IsReject(itemId == "0" || itemId == "" || itemLevel <= 2, "센터명을 선택해주세요",item)) return false;
      //
      //
      // item = document.getElementById("<%= txtPROC_UNIT_PRICE2.ClientID %>");
      // if(IsReject(item.value == "","단가를 입력해주세요",item)) return false;
      //
      // return confirm("저장 하시겠습니까?");




      return true;
    },
    /**
     * 저장/수정
     */
    save() {

      const param = JSON.parse(JSON.stringify(this.$refs.productInstallEditInfo.form));
      const stripFields = ['requestDt', 'requestNm'];
      _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]));

      if(param.siteType == ''){
        this.$swal({ type: 'warning', text: '찾기버튼을 통해서 사이트를 선택해주세요.' });
        return false;
      }

      if(param.saleDeptNm == ''){
        this.$swal({ type: 'warning', text: '영업부서를 입력 바랍니다.' });
        return false;
      }

      if(param.saleChargeNm == ''){
        this.$swal({ type: 'warning', text: '영업담당을 입력 바랍니다.' });
        return false;
      }

      if(param.setupUnitPrice2 == ''){
        this.$swal({ type: 'warning', text: '설치비(2)를 입력 바랍니다.' })
        return false;
      }

      if(param.setupEtcPrice1 == ''){
        this.$swal({ type: 'warning', text: '출장급지를 입력 바랍니다.' })
        return false;
      }

      if(param.setupEtcPrice2 == ''){
        this.$swal({ type: 'warning', text: '기타비용을 입력 바랍니다.' })
        return false;
      }

      let vSaveForm = {
        companyId : this.form.companyId,
        requestDt : this.$refs.productInstallEditInfo.form.requestDt,
        requestNm : this.$refs.productInstallEditInfo.form.requestNm,
        requestSetupDt : this.$refs.productInstallEditInfo.form.requestSetupDt,
        siteId : this.$refs.productInstallEditInfo.form.siteId,
        memo : this.$refs.productInstallEditInfo.form.memo,
        saleDeptNm : this.$refs.productInstallEditInfo.form.saleDeptNm,
        saleChargeNm : this.$refs.productInstallEditInfo.form.saleChargeNm,
        setupUnitPrice1 : this.getNumberFormat(this.$refs.productInstallEditInfo.form.setupUnitPrice1),
        setupUnitPrice2 : this.getNumberFormat(this.$refs.productInstallEditInfo.form.setupUnitPrice2),
        setupEtcPrice1 : this.getNumberFormat(this.$refs.productInstallEditInfo.form.setupEtcPrice1),
        setupEtcPrice2 : this.getNumberFormat(this.$refs.productInstallEditInfo.form.setupEtcPrice2),
        asAgentId : this.$refs.productInstallEditInfo.form.subCatId,
        requestId : this.$refs.productInstallEditInfo.form.requestId,
      }

      let itemData = this.$refs.productInstallEditInfo.data;
      let submitList = [];
      let delData = this.$refs.productInstallEditInfo.delData;

      if(itemData.length == 0){
        this.$swal({ type: 'warning', text: '설치모델을 입력 바랍니다.' })
        return false;
      }

      for(var i=0; itemData.length > i; i++){
        if(itemData[i].purchaseDt == '' ||  itemData[i].guaranteeStartDt == '' || itemData[i].guaranteeEndDt == '' ||
            itemData[i].modelQty == ''|| itemData[i].modelQty == undefined  ){
          this.$swal({ type: 'warning', text: '설치모델 필수 값을 입력 바랍니다.' })
          return false;
        }

        submitList.push({
          companyId : this.$store.state.loginInfo.compCd,
          requestId : this.$refs.productInstallEditInfo.form.requestId,
          modelId : itemData[i].modelId,
          guaranteeStartDt : this.$moment(itemData[i].guaranteeStartDt).format('YYYY-MM-DD'),
          guaranteeEndDt : this.$moment(itemData[i].guaranteeEndDt).format('YYYY-MM-DD'),
          purchaseDt : itemData[i].purchaseDt,
          prodDt : this.$refs.productInstallEditInfo.form.prodDt,
          modelQty : itemData[i].modelQty,
          modelSetupInfoId : itemData[i].modelSetupInfoId == undefined ? 0 : itemData[i].modelSetupInfoId,
        });
      }

      this.$swal({
        type: 'warning',
        text: `저장 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          this.$http.post(("/api/workMng/productInstallEdit/save"), vSaveForm).then(response => {
            if(response.data.indexOf("ST") !== -1) {
              submitList.forEach(x => {
                x.requestId = response.data;
              })
            }
            if(delData.length>0){ // 삭제한 내용이 있다면
              this.$http.post(("/api/workMng/productInstallEdit/item/cancel"), delData).then(response => {
                this.$http.post(("/api/workMng/productInstallEdit/item/save"), submitList).then(response => {
                  this.$swal({ type: 'success', text: '저장되었습니다.' })
                  this.goOpen();
                }).catch((e) => {
                  this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
                })
              }).catch((e) => {
                this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
              })
            }else{
              this.$http.post(("/api/workMng/productInstallEdit/item/save"), submitList).then(response => {
                this.$swal({ type: 'success', text: '저장되었습니다.' })
                this.goOpen();
              }).catch((e) => {
                this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
              })
            }
          }).catch((e) => {
            console.error(e);
            this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
          }).finally(() => {
            this.$store.commit('finish')
          });
        }
      });

      if(this.$refs.productInstallEditInfo.form.requestId.length === 0){
        // save
      } else {
        // update
      }


    },
    getNumberFormat(val) {
      if(val){

        if(typeof val === "string"){
          val = val.replace(/,/g, "")
        }
        return parseInt(val);
        // return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>